import React from "react";
import { Link } from "react-router-dom";
import CartIcon from "../common/CartIcon";
import UserIcon from "../common/UserIcon";
import WalletIcon from "../common/WalletIcon";
import ThemeToggle from "../ui/ThemeToggle";
import "./MainHeader.css";

const MainHeader = ({ animationState }) => (
  <header className={`header ${animationState !== "navbarVisible" ? "header-hidden" : ""}`}>
      <Link to="/" className="logo" aria-label="لاویسا — صفحه اصلی">
        LAVVISSA
      </Link>
      <nav className="nav desktop-nav" aria-label="ناوبری اصلی">
        <ul>
          <li>
            <Link to="/">خانه</Link>
          </li>
          <li>
            <Link to="/shop">فروشگاه</Link>
          </li>
          <li>
            <a href="/#about">درباره ما</a>
          </li>
          <li>
            <a href="/#contact">تماس با ما</a>
          </li>
        </ul>
      </nav>
      <nav className="nav-icons" aria-label="دسترسی سریع">
        <div className="desktop-nav-control">
          <ThemeToggle />
        </div>
        <Link
          to="/shop"
          className="header-action mobile-shop-link"
          aria-label="فروشگاه"
        >
          <span className="icon shop-icon" aria-hidden="true" />
        </Link>
        <CartIcon />
        <UserIcon />
        <div className="desktop-nav-control">
          <WalletIcon />
        </div>
      </nav>
  </header>
);

export default MainHeader;
